import React, { Children } from 'react';
import { PolicyLayout } from '../components/layout/PolicyLayout';
export function PrivacyPolicyPage() {
  const sections = [{
    id: 'introduction',
    title: 'Introduction',
    content: <>
          <p data-id="element-8529" data-mp="2mtiwyg3sg0xb">
            At Innova Pharmacy, we are committed to protecting your privacy and
            ensuring the security of your personal information. This Privacy
            Policy explains how we collect, use, disclose, and safeguard your
            information when you visit our website or use our services.
          </p>
          <p className="mt-4" data-id="element-8530" data-mp="2iua1n6t3nuzn">
            By using our services, you agree to the collection and use of
            information in accordance with this policy. If you do not agree with
            our policies and practices, please do not use our services.
          </p>
        </>
  }, {
    id: 'information-collection',
    title: 'Information We Collect',
    content: <>
          <p className="mb-4" data-id="element-8531" data-mp="29rmvlnf27y6c">
            We collect several types of information from and about users of our
            services:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8532" data-mp="24rqohfb2fqmk">
            <li data-id="element-8533" data-mp="2jpj2g30ys6yn">
              <strong data-id="element-8534" data-mp="2jq2l5lyfuzdq">Personal Information:</strong> Name, email address, phone
              number, delivery address, date of birth, and payment information.
            </li>
            <li data-id="element-8535" data-mp="1r1557php9eo5">
              <strong data-id="element-8536" data-mp="1r0lxf1lrk6nu">Health Information:</strong> Prescription details, medical
              history, and health-related preferences (only when voluntarily
              provided).
            </li>
            <li data-id="element-8537" data-mp="20rgku9aqxcav">
              <strong data-id="element-8538" data-mp="20s017lkqzsms">Account Information:</strong> Username, password, order
              history, and loyalty points.
            </li>
            <li data-id="element-8539" data-mp="1vy59buuzo7cm">
              <strong data-id="element-8540" data-mp="1vydppwqblusk">Technical Information:</strong> IP address, browser type,
              device information, and cookies.
            </li>
            <li data-id="element-8541" data-mp="13ahtsu8ks6wu">
              <strong data-id="element-8542" data-mp="13b1cid61uzbx">Usage Information:</strong> Pages visited, time spent on
              pages, and interaction with our services.
            </li>
          </ul>
        </>
  }, {
    id: 'how-we-use',
    title: 'How We Use Your Information',
    content: <>
          <p className="mb-4" data-id="element-8543" data-mp="21tbc9b8tgsw9">
            We use the information we collect for various purposes:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8544" data-mp="26qbjhphek1oy">
            <li data-id="element-8545" data-mp="1a1c8i2pfolt2">Processing and fulfilling your orders</li>
            <li data-id="element-8546" data-mp="1a2x66171okv5">Verifying prescriptions and ensuring medication safety</li>
            <li data-id="element-8547" data-mp="1e37dbh6kphbl">
              Communicating with you about orders, deliveries, and account
              updates
            </li>
            <li data-id="element-8548" data-mp="1j3vaylpb4wes">Providing customer support and responding to inquiries</li>
            <li data-id="element-8549" data-mp="1o26k0u7s32vy">
              Personalizing your experience and recommending relevant products
            </li>
            <li data-id="element-8550" data-mp="2uis2c28yrxpb">Processing payments and preventing fraud</li>
            <li data-id="element-8551" data-mp="2zepj29o5362m">
              Sending promotional offers and marketing communications (with your
              consent)
            </li>
            <li data-id="element-8552" data-mp="nuhxkjzpavy7">Improving our website, services, and customer experience</li>
            <li data-id="element-8553" data-mp="itu9a62uwt7o">
              Complying with legal obligations and regulatory requirements
            </li>
          </ul>
        </>
  }, {
    id: 'information-sharing',
    title: 'Information Sharing and Disclosure',
    content: <>
          <p className="mb-4" data-id="element-8554" data-mp="527c8413bgnu">
            We do not sell your personal information. We may share your
            information with:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8555" data-mp="1jdsxaj7xjl">
            <li data-id="element-8556" data-mp="3r8cb3q27fciu">
              <strong data-id="element-8557" data-mp="3r9x5nfoiqvgp">Service Providers:</strong> Third-party companies that
              help us operate our business (payment processors, delivery
              partners, IT services).
            </li>
            <li data-id="element-8558" data-mp="1pghg6m463mnb">
              <strong data-id="element-8559" data-mp="1pgzhvy9lmt2m">Healthcare Professionals:</strong> Licensed pharmacists
              and doctors for prescription verification and consultation
              services.
            </li>
            <li data-id="element-8560" data-mp="1sjwxoec366df">
              <strong data-id="element-8561" data-mp="1shaqift3xsvq">Legal Authorities:</strong> When required by law, court
              order, or to protect our rights and safety.
            </li>
            <li data-id="element-8562" data-mp="1ilzazv9vkhmx">
              <strong data-id="element-8563" data-mp="1ikei0a37l6r6">Business Transfers:</strong> In connection with a merger,
              acquisition, or sale of assets.
            </li>
          </ul>
          <p className="mt-4" data-id="element-8564" data-mp="19t5tdr6yh65w">
            All third parties are required to maintain the confidentiality of
            your information and use it only for the purposes we specify.
          </p>
        </>
  }, {
    id: 'data-security',
    title: 'Data Security',
    content: <>
          <p data-id="element-8565" data-mp="14t9lvhz1uwll">
            We implement appropriate technical and organizational security
            measures to protect your personal information against unauthorized
            access, alteration, disclosure, or destruction. These measures
            include:
          </p>
          <ul className="list-disc pl-6 space-y-2 mt-4" data-id="element-8566" data-mp="c7bd70f0epkq">
            <li data-id="element-8567" data-mp="c7us089d4xuj">SSL encryption for data transmission</li>
            <li data-id="element-8568" data-mp="78rm6llk6nli">Secure servers and encrypted databases</li>
            <li data-id="element-8569" data-mp="7ab6cnac5isk">Regular security audits and updates</li>
            <li data-id="element-8570" data-mp="l92fdvacce9u">Access controls and authentication protocols</li>
            <li data-id="element-8571" data-mp="g8wkm68rybnj">Employee training on data protection</li>
          </ul>
          <p className="mt-4" data-id="element-8572" data-mp="g7lisbyw3dz2">
            However, no method of transmission over the internet or electronic
            storage is 100% secure. While we strive to protect your information,
            we cannot guarantee absolute security.
          </p>
        </>
  }, {
    id: 'your-rights',
    title: 'Your Rights and Choices',
    content: <>
          <p className="mb-4" data-id="element-8573" data-mp="zxffn4ggoja5">
            You have the following rights regarding your personal information:
          </p>
          <ul className="list-disc pl-6 space-y-2" data-id="element-8574" data-mp="1dukdih60ubub">
            <li data-id="element-8575" data-mp="18yn0oktyvnma">
              <strong data-id="element-8576" data-mp="18z55i5up3a5t">Access:</strong> Request a copy of the personal
              information we hold about you.
            </li>
            <li data-id="element-8577" data-mp="6ico63qlyiir">
              <strong data-id="element-8578" data-mp="alhr27elom7x">Correction:</strong> Update or correct inaccurate
              information.
            </li>
            <li data-id="element-8579" data-mp="fkc6czdczsna">
              <strong data-id="element-8580" data-mp="fjszcdp8yoo1">Deletion:</strong> Request deletion of your personal
              information (subject to legal obligations).
            </li>
            <li data-id="element-8581" data-mp="kdf4zlwztsac">
              <strong data-id="element-8582" data-mp="paxdxcb0g7ic">Opt-Out:</strong> Unsubscribe from marketing
              communications at any time.
            </li>
            <li data-id="element-8583" data-mp="u8yu9ph1xsq4">
              <strong data-id="element-8584" data-mp="u8fcc8rej4c3">Data Portability:</strong> Request your data in a portable
              format.
            </li>
            <li data-id="element-8585" data-mp="yc4y6qgoz7tf">
              <strong data-id="element-8586" data-mp="y9iux30u3eh0">Withdraw Consent:</strong> Withdraw consent for data
              processing where applicable.
            </li>
          </ul>
          <p className="mt-4" data-id="element-8587" data-mp="303rwld2wy4zx">
            To exercise these rights, please contact us at
            privacy@innovapharmacy.com or through your account settings.
          </p>
        </>
  }, {
    id: 'cookies',
    title: 'Cookies and Tracking Technologies',
    content: <>
          <p data-id="element-8588" data-mp="2sqscllddrjrz">
            We use cookies and similar tracking technologies to enhance your
            browsing experience, analyze site traffic, and personalize content.
            Cookies are small data files stored on your device.
          </p>
          <p className="mt-4" data-id="element-8589" data-mp="3gh4qdcvb4aqh">
            You can control cookies through your browser settings. However,
            disabling cookies may limit your ability to use certain features of
            our website.
          </p>
        </>
  }, {
    id: 'children-privacy',
    title: "Children's Privacy",
    content: <>
          <p data-id="element-8590" data-mp="32glpcpp9e4xt">
            Our services are not intended for individuals under the age of 18.
            We do not knowingly collect personal information from children. If
            we become aware that we have collected information from a child
            without parental consent, we will take steps to delete that
            information.
          </p>
        </>
  }, {
    id: 'changes',
    title: 'Changes to This Privacy Policy',
    content: <>
          <p data-id="element-8591" data-mp="3h7bjly105wzg">
            We may update this Privacy Policy from time to time to reflect
            changes in our practices or legal requirements. We will notify you
            of any material changes by posting the new policy on this page and
            updating the "Last Updated" date.
          </p>
          <p className="mt-4" data-id="element-8592" data-mp="hpv95njxmx8i">
            We encourage you to review this Privacy Policy periodically to stay
            informed about how we protect your information.
          </p>
        </>
  }, {
    id: 'contact',
    title: 'Contact Us',
    content: <>
          <p className="mb-4" data-id="element-8593" data-mp="wnnlk6u6n5ih">
            If you have any questions, concerns, or requests regarding this
            Privacy Policy or our data practices, please contact us:
          </p>
          <ul className="list-none space-y-2" data-id="element-8594" data-mp="1asw9vr8pmnhi">
            <li data-id="element-8595" data-mp="1arl5bp7fxbpc">
              <strong data-id="element-8596" data-mp="16sm4afotxz36">Email:</strong> privacy@innovapharmacy.com
            </li>
            <li data-id="element-8597" data-mp="16qjg8178mg13">
              <strong data-id="element-8598" data-mp="1kjhhu5a9x4d3">Phone:</strong> +966 920 000 000
            </li>
            <li data-id="element-8599" data-mp="1klv9s59nq0gf">
              <strong data-id="element-8600" data-mp="1fko2s8fc95at">Address:</strong> Riyadh, Kingdom of Saudi Arabia
            </li>
          </ul>
        </>
  }];
  return <PolicyLayout title="Privacy Policy" description="Your privacy is important to us. Learn how we collect, use, and protect your personal information." lastUpdated="January 15, 2025" sections={sections} seoTitle="Privacy Policy - Innova Pharmacy" seoDescription="Read Innova Pharmacy's Privacy Policy to understand how we collect, use, and protect your personal and health information in compliance with data protection laws." canonical="/privacy-policy" data-id="element-8601" data-mp="rw4u3rsdmqi7" />;
}